import React, { useRef, useEffect, useState } from "react";

import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader, 
  ModalBody,
  FormGroup,
  ModalFooter,
} from "reactstrap";

const NuInputBox =(props) =>{
  const [value, setValue] = useState("");

  //const [show, setShow] = useState(false);
  /*const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);*/
  function handleChange(e) {
        setValue(e.target.value);
  }
  function onHandleOK(e){
    e.preventDefault();
    //props.handleOK(value);
    props.handleOK(value)
  }
  return(
    
    <Modal isOpen={ props.modalShow }>
      {/*<Modal isOpen={ props.modalShow}>*/}
    <ModalHeader>
     <div><h3>{props.titulo}</h3></div>
     { 
     //JSON.stringify(props)
     }
    </ModalHeader>

    <ModalBody>
      
      <FormGroup>
        <label>
          {props.mensaje}
        </label>
        <input
          className="form-control"
          name="personaje"
          type="text"
          onChange={ handleChange}
          value={ value }
        />
      </FormGroup>
      
    </ModalBody>

    <ModalFooter>
      <Button
        color="primary"
        onClick={ (e)=>onHandleOK(e)}
      >
        Aceptar
      </Button> &nbsp;&nbsp;
      <Button
        color="danger"
        onClick={() => { props.handleCancel()}}
      >
        Cancelar
      </Button>
    </ModalFooter>
  </Modal>
  )
}
export default NuInputBox;